import { Record } from 'immutable';

const CountryConfigLookupRecord = Record({
  agencyCountry: null,
  vendorCountry: null
});

export class CountryConfigLookup extends CountryConfigLookupRecord {
  agencyCountry: string;
  vendorCountry: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/country-config-lookup.ts